import React from 'react'
// hooks
import { useCurrentTable } from 'hooks/risks'
// types
import { IFieldLink } from 'types/graphql'

export const useColumnsHeight = (column: IFieldLink, columnId = column.id) => {
  const ref = React.useRef<HTMLDivElement | null>(null)

  const { setColumnHeight, removeColumnHeight } = useCurrentTable()

  React.useEffect(() => {
    if (!ref.current) {
      return
    }

    const el = ref.current

    const height = Math.round(el.getBoundingClientRect().height)
    setColumnHeight({ ...column, id: columnId }, height)

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]

      if (!entry) {
        return
      }

      const nextHeight = Math.round(entry.contentRect.height)

      setColumnHeight({ ...column, id: columnId }, nextHeight)
    })

    observer.observe(el)

    return () => {
      observer.disconnect()
      removeColumnHeight(columnId)
    }
  }, [column, columnId, setColumnHeight, removeColumnHeight])

  return { ref }
}
